import React from 'react';
import {useNavigate} from 'react-router-dom';

import {createEventReviewRoutePath} from 'src/modules/event-review/event-review-route-planner';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';

type Props = {
    changeRequestId: number,
    code: string,
    source: string,
};

export const PushNotificationBeforeReviewTab = ({changeRequestId, code, source}: Props) => {
    const navigate = useNavigate();

    const onClick = () => {
        const eventReviewRoutePath = createEventReviewRoutePath({changeRequestId});
        navigate(eventReviewRoutePath);
    };

    return (
        <Group justify="space-between" style={{maxWidth: '90%'}}>
            <Group direction="v" gap="s" style={{minWidth: '70%'}}>
                <Group gap="xs">
                    <Item shrink={0}>Change request for event code</Item>
                    <EllipsisTextHint bold={true}>{code}</EllipsisTextHint>
                </Group>
                <Group justify="start">
                    <Item>with the same source <strong>{source}</strong> is proceeding...</Item>
                </Group>
            </Group>
            <FlatButton onClick={onClick}>See Change Request</FlatButton>
        </Group>
    );
};
